// @flow
import React, { type Node } from 'react';
import { Panel, Row, Col, RatingDisplay } from 'angieslist-react-components';
import { stylesColors as colors } from 'angieslist-styles';
import { legacyAnalytics, LegacyTrack, urlCatalog } from 'angieslist-app-platform';
import { compose, pure } from 'recompose';
import { connect } from 'react-redux';
import { get } from 'lodash';
import businessInfoPanelAnalytics from './businessInfoPanelAnalytics';
import BusinessNav from './BusinessNav';
import type { ServiceProvider, Entitlement } from '../types';
import './businessInfoPanel.scss';

const formatAddress = ({
  addressFirstLine = '', addressSecondLine = '', city = {}, region = {}, postalCode = '',
} = {}) => {
  const addressArray = [addressFirstLine, addressSecondLine, city.name, region.name, postalCode];
  return addressArray.filter(x => x).join(', ');
};

export type BusinessInfoPanelProps = {
  activityLocation: string,
  serviceProvider: ServiceProvider,
  showBusinessListLink: boolean,
  experiment: any,
  entitlements: Entitlement[],
  config: any,
};

const businessListColMd = 2;
const nameColMd = 5;


export const BusinessInfoPanelComponent = ({
  activityLocation,
  serviceProvider,
  showBusinessListLink,
  experiment,
  entitlements,
  config,
}: BusinessInfoPanelProps): Node => {
  const enableBmtQuickBooksSync = get(experiment, 'experiments.enableBmtQuickBooksSync.enabled', false);
  const reviewsLink = urlCatalog.office.reviews(serviceProvider.id);
  const { accountingSyncUrl } = config;

  return (
    <Panel className="business-info--panel">
      <Row className="business-info--sp-info-row">
        <If condition={showBusinessListLink}>
          <Col xs={12} md={businessListColMd}>
            <div className="business-info--business-list">
              <LegacyTrack>
                <a
                  href="/app/home"
                  id={`business-info--business-list-link-${serviceProvider.id}`}
                  className="text-secondary"
                  data-track-service-provider-id={serviceProvider.id}
                  data-track-activity-location={activityLocation}
                >
                  <i className="icon icon-left-open icon-lg business-info--business-list-icon" />
                  <strong>&nbsp;&nbsp;Business List</strong>
                </a>
              </LegacyTrack>
            </div>
          </Col>
        </If>
        <Col
          xs={12}
          md={showBusinessListLink ? nameColMd : nameColMd + businessListColMd}
          className="business-info--sp-info-section"
        >
          <div className="business-info--name-address-display">
            <LegacyTrack>
              <a
                href={`/app/home/${serviceProvider.id}`}
                id={`business-info--business-list-name-link-${serviceProvider.id}`}
                aria-label="View Business"
                data-track-service-provider-id={serviceProvider.id}
                data-track-activity-location={activityLocation}
                className="text-info"
              >
                <strong style={{ color: colors.textHeadlineDark, fontSize: '24px' }}>{serviceProvider.name}&nbsp;</strong>
              </a>
            </LegacyTrack>
          </div>
          <div className="business-info--grade-review-display">
            <RatingDisplay
              customId="business-info--rating-display"
              rating={serviceProvider.starRating}
              starSize="1em"
              ratingFontSize="1em"
              reviewsFontSize="0.9em"
              reviewCount={serviceProvider.displayReviewCount}
              emptyStarColor="#DBDBDB"
              reviewCountLink={
                <LegacyTrack>
                  <a
                    href={reviewsLink}
                    id="business-info--review-count-link"
                    data-track-activity-location={activityLocation}
                  ><strong>{serviceProvider.displayReviewCount} Verified Reviews </strong>
                  </a>
                </LegacyTrack>
              }
            />
            <strong><span className="business-info--spid-display">SPID: {serviceProvider.alId}</span></strong>
          </div>
          <div className="business-info--name-address-display">
            <strong><span style={{ fontSize: '18px' }}>{formatAddress(serviceProvider.primaryAddress)}</span></strong>
          </div>
        </Col>
        {/*
          md={4} here would add to 12 for all md cols in this row
          but the nav goes off the screen at some md sizes
          so we cheat and make it 5 which gives it a higher
          weight to make it slightly wider.
          It all stays on one line because it's also using Flex.
       */}
        <Col xs={12} md={5}>
          <BusinessNav
            activityLocation={activityLocation}
            serviceProvider={serviceProvider}
            enableBmtQuickBooksSync={enableBmtQuickBooksSync}
            entitlements={entitlements}
            accountingSyncUrl={accountingSyncUrl}
            experiment={experiment}
          />
        </Col>
      </Row>
    </Panel>
  );
};

export default (compose(
  legacyAnalytics({
    ruleset: businessInfoPanelAnalytics,
  }),
  connect(state => ({
    experiment: state.experimentV2,
    config: state.config,
  })),
  pure,
)(BusinessInfoPanelComponent): any);



// WEBPACK FOOTER //
// ./src/app/browser/BusinessInfoPanel.js